goog.provide('el8.practicedata.unfiledInboxes');

goog.require('el8.service.urls');
goog.require('el8.model.base');


el8.practicedata.unfiledInboxes = (function() {

    /** Important to note -- the "manual" inbox has an ID of "manual" **/

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addStringProperty('displayFax');
    _class.addStringProperty('fax');
    _class.addIntProperty('count');

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('loadUnfiledInboxes'); }
    });

    that.getTotalCount = function() {
        var count = 0;
        var all = that.all();
        for (var i=0; i<all.length; i++) {
            count += all[i].getCount();
        }
        return count;
    };

    /**
     * Implement a "thoughtfulLoad" that rate limites the number of load()
     * requests that this entitySet allows
     */
    that._requestQueued = false;
    that._inWaitMode = false;
    that.thoughtfulLoad = function() {
        var _doLoad = function() {
            if (that._inWaitMode) { return; }
            that._inWaitMode = true;
            that.load(function() {
                $.el8_setTimeout(function() {
                    that._inWaitMode = false;
                    if (that._requestQueued) {
                        that._requestQueued = false;
                        _doLoad();
                    }
                }, 5*1000);  // 5 seconds
            });
        };
        if (that._inWaitMode) {
            that._requestQueued = true;
        } else {
            _doLoad();
        }
    };

    return that;

})();

